export default __webpack_public_path__ + "static/social-banner-f50adb85f6cadb7553ec9527aa32c652.jpg";